<template>
  <div>
    <base-header style="background-color: #f8f9fe !important">
      <div v-if="meta && meta.serviceRequestNumber">
        <h4>Service Request Number - {{ meta.serviceRequestNumber }}</h4>
      </div>
      <div v-if="meta && meta.averagePoints">
        <h4>
          Vendor's Average Points For This Request - {{ meta.averagePoints }}
          <i class="el-icon-coin"></i>
        </h4>
      </div>
    </base-header>
  </div>
</template>
<script>
export default {
  props: {
    buttons: {
      type: Array,
      default: () => []
    },
    meta: {
      type: Object,
      default: () => {}
    }
  },
  data: () => {
    return {};
  },
  methods: {
    showFilters() {
      this.$emit("showFilters");
    }
  }
};
</script>
